class MathUtils {

  static precisionRound(value, decimals) {
    return parseFloat(value.toFixed(decimals));
  }

}

export default MathUtils;